<m27-page>
    <m27-page-banner [pageTitle]="'Home'"></m27-page-banner>
    <m27-page-body>
        <m27-page-section [caption]="'Release History'" class="release-notes">
            <div>
                November 10, 2022 - v2.2
                <ul>
                    <li> Current Year + 1 now shows up on October 1st instead of December 1st. <link area="permitting" /> <link story="25404" /></li>
                </ul>
            </div>
            <div>
                October 19, 2022 - v2.2
                <ul>
                    <li> City and Postal Code added to E-File Submission XML file. <link area="permitting" /> <link story="25404" /></li>
                </ul>
            </div>
            <div>
                June 16, 2021 - v2.2
                <ul>
                    <li> Authorization ID to display in all reports that contain permit information. <link area="reporting" /> <link story="15338" /></li>
                    <li> Fixed Force Xml button on Planting and Not-Planted Reports. Button is only visible if it will create a file. <link area="reporting" /> <link bug="15598" /></li>
                </ul>
            </div>
            <div>
                March 15, 2021 - v2.1
                <ul>
                    <li> Volunteer Report Efile <link area="reporting" /></li>
                    <li> Final Field Test Report Efile <link area="reporting" /></li>
                    <li> Authorization ID to display in Report results and Permit Search results <link area="reporting" /></li>
                    <li> Efile XML encoding fixed from UTF-8-BOM to UTF-8 <link area="reporting" /> <link area="permitting" /></li>
                </ul>
            </div>
            <div>
                January 6, 2021 - v2.0
                <ul>
                    <li>
                        E-File XML Submissions: <link area="reporting" /> <link area="permitting" />
                        <ul>
                            <li>
                                These XMLs are for full permits in the United States only
                                <ul>
                                    <li>Full Permit - U.S. Field Release and Movement</li>
                                    <li>Full Permit - U.S. Movement</li>
                                    <li>Full Permit - U.S. Field Release</li>
                                    <li>Full Permit - U.S. Importation</li>
                                </ul>
                            </li>
                            <li>
                                This functionality will not be used for Notifications which are due to be discontinued for the US in 2021.
                                (Permit Manager will continue to be the application for adding/updating permit information.)
                            </li>
                            <li>Denodo views will be used for Feature and Construct information</li>
                            <li>Add ApplicantReferenceNumber</li>
                            <li>All phone numbers now begin with '+'. The extension structure has been simplified. An Alternate Telephone number has been added. </li>
                            <li>The format for CBI has been changed for many fields. Additional fields added to list of CBI fields (Square brackets no longer work for some fields)</li>
                            <li>Add NumberofLabelsImport to the Import permit XML - defaulted to 16</li>
                            <li>VarianceDescription now warns if over 255 characters - will truncate for XML</li>
                            <li>Add more Location information - Name, Description, Address lines 1-4, County, Postal Code, State, Location Unique ID</li>
                            <li>More than one Article Supplier is now supported in efiles for future purposes</li>
                        </ul>
                    </li>
                    <li>
                        Data Integrity items were fixed <link area="reporting" />
                        <ul>
                            <li>
                                Mode of transformation
                                <ul>
                                    <li>'Disarmed Agrobacterium tumefaciens' will be updated to 'Agrobacterium tumefaciens, disarmed'</li>
                                    <li>'[Disarmed Agrobacterium tumefaciens]' will be updated to '[Agrobacterium tumefaciens, disarmed]'</li>
                                    <li>'Disarmed Agrobacterium rhizogene' will be updated to 'Agrobacterium rhizogene, disarmed'</li>
                                </ul>
                            </li>
                            <li>Pounds instead of Lbs</li>
                            <li>Gene of Interest to Gene(s) of Interest</li>
                            <li>Common name for "Soybeans" will be updated to "Soybean" for permit XMLs.</li>
                            <li>Permit Phenotype Category updates:</li>
                            <li>Add VR - Virus Resistance</li>
                            <li>Update - APHT to APHR Agronomic Properties/Herbicide Resistance</li>
                            <li>Update - HT to HR Herbicide Resistance</li>
                            <li>Update - IRHT to IRHR Insect Resistance/Herbicide Resistance</li>
                            <li>Update - FR Fungus Resistant to Fungal Resistance</li>
                            <li>Update - IR Insect Resistant to Insect Resistance</li>
                            <li>Update - MG Marker Genes to Marker Gene</li>
                        </ul>
                    </li>
                    <li>Planting Report - Moved the "Force XML on Errored Permits" button to the XML/Snapshot Status screen. It will work only if there are new plantings for the permit, or when the user chooses to include locations with no new plantings <link area="reporting" /></li>
                    <li>Planting Report/Not Planted Report - Authorization ID (Written into ApplicationID field) has been added to the E-file XML <link area="reporting" /></li>
                    <li>Final Field Test Report - Destruction Description and In Field Termination description fields are now longer for the XML <link area="reporting" /></li>
                </ul>
            </div>
            <div>
                August 14, 2020
                <ul>
                    <li>Final Field Test Report - updated "Destruction Description" column to allow 150 characters. Reports failed containing permit 0016-CRN-US-2019 <link area="reporting" /> <link jira="vrr-1500" /></li>
                </ul>
            </div>
            <div>
                July 7, 2020
                <ul>
                    <li>Constructs show up on an experiment/location basis now rather than for the location <link area="reporting" /> <link jira="vrr-1494" /></li>
                </ul>
            </div>
            <div>
                May 29, 2020
                <ul>
                    <li>Planting Report XML/Snapshot override for PHOBs <link area="reporting" /> <link jira="vrr-1469" /></li>
                </ul>
            </div>
            <div>
                January 2, 2020 - v1.44
                <ul>
                    <li>Final Field Test Report - update Report and XML to Corteva Agriscience for Storage Description <link area="reporting" /> <link jira="vrr-1329" /></li>
                </ul>
            </div>
            <div>
                December 4, 2019 - v1.42
                <ul>
                    <li>Volunteer Report - Observation Detail Comment tag must include an 'S' <link area="reporting" /> <link jira="vrr-1320" /></li>
                </ul>
            </div>
            <div>
                December 2, 2019
                <ul>
                    <li>Volunteer Report - Concatenating Permits from different locations within a site for plantbacks. (Unique list) <link area="reporting" /> <link jira="vrr-1295" /></li>
                </ul>
            </div>
            <div>
                November 14, 2019
                <ul>
                    <li>Regulated RegComp Report - Information dates released <link area="reporting" /></li>
                </ul>
            </div>
            <div>
                August 19, 2019
                <ul>
                    <li>Final Field Test Report released <link area="reporting" /></li>
                </ul>
            </div>
            <div>
                August 7, 2019
                <ul>
                    <li>Hotfix - Planting Report XMLs now generated for 'good' permits when there are both 'good' and 'error' permits in the request <link area="reporting" /></li>
                </ul>
            </div>
            <div>
                July 10, 2019
                <ul>
                    <li>Hotfix - Volunteer Report XML - Drop 'No Monitoring' tag so XML will load to USDA site <link area="reporting" /> <link jira="vrr-1170" /></li>
                </ul>
            </div>
            <div>
                June 27, 2019
                <ul>
                    <li>Corteva look and feel applied <link area="site" /></li>
                    <li>Now displays the Users 'Display Name' instead of their username <link area="site" /></li>
                    <li>
                        Planting Report updates: <link area="reporting" />
                        <ul>
                            <li>The Calendar feature has been implemented for the Plant Date Range</li>
                            <li>'Reported Acres' column name updated to 'Reported Acres By Permit/Loc'</li>
                        </ul>
                    </li>
                    <li>
                        Volunteer Report released: <link area="reporting" />
                        <ul>
                            <li>Basic User Interface is similar to the Planting Report and Not Planted Report</li>
                            <li>Multiple crops and permits may be run in the same job. Excel and XML output will put out one file for each permit</li>
                            <li>User may run report based on Current Data or on Draft Data (Uncheck the Get Current Data box on the request screen)</li>
                            <li>The automation from Num Volunteers to Num for XML has been maintained</li>
                            <li>6 columns are editable on the screen : Monitoring Start Date, Monitoring End Date, Observation Date, # Volunteers for XML, Unit and Action Taken</li>
                            <li>There is a pop-up to display the Cultivation date(s) that feed the Monitoring Start Date Column</li>
                            <li>Save Draft button and ribbon will indicate whether there are unsaved changes </li>
                            <li>Pop-up box for Export to XML will indicate what XML permit files have been generated</li>
                            <li>Constructs now display for only the primary permit (constructs are now specific to the permit, experiment, and location)</li>
                        </ul>
                    </li>
                    <li>
                        USDA Mid 2019 Requirements (Changes in Gatekeeper - not Permit Manager Reports): <link area="reporting" />
                        <ul>
                            <li>Anticipated Harvest Date - Added to Planting Report</li>
                            <li>Intended Volunteer Monitoring Method - Added to Volunteer Report</li>
                            <li>Location of Volunteers - Added to Volunteer Report</li>
                            <li>Expected Date Volunteers will be removed/Destroyed - Added to Volunteer Report</li>
                            <li>
                                3 Dropdowns Were updated:
                                <ul>
                                    <li>Disposition of Vegetative Material - Destruct Report in BTM and Draft Maintenance</li>
                                    <li>Disposition of Unwanted Seed/Grain - Harvest Report in BTM and Draft Maintenance</li>
                                    <li>Method used to Destroy Volunteers - Post Trial Monitoring Report in BTM and Draft Maintenance (And Action Taken field on Volunteer Report)</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div>
                June 7, 2019
                <ul>
                    <li>Saving Snapshot properly for CBI columns for not planted report <link area="reporting" /></li>
                </ul>
            </div>
            <div>
                May 29, 2019
                <ul>
                    <li>Saving snapshot properly for Plant Start Date <link area="reporting" /></li>
                </ul>
            </div>
            <div>
                April 13, 2019
                <ul>
                    <li>Initial Release <link area="site" /></li>
                    <li>Planting Report <link area="reporting" /></li>
                    <li>Not-Planted Report <link area="reporting" /></li>
                </ul>
            </div>
        </m27-page-section>
    </m27-page-body>
</m27-page>
